<template>
  <div>
    <div class="page page__list" v-if="filters[0].name == 'pu_date'">
      <search-bar
        @search="onSearch"
        name="pu_code,pu_vendname,pu_remark"
        placeholder="输入单据编号、供应商、备注进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.pu_id"
          :to="'/purchase/order/'+item.pu_id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pu_vendname}}</p>
            <p class="list-item-muted">{{item.pu_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.pu_total')">{{item.pu_total}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.pu_status!='已审核'}"
            >{{item.pu_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}笔</label>
        <em class="list-footer__value" v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.pu_total')">{{getTotal('pu_total')}}</em>
      </div>
      <add-button to="/purchase/order_edit" />
    </div>

    <div class="page page__list" v-if="filters[0].name == 'PurchaseChange.createTime'">
      <search-bar
        @search="onSearch"
        name="pc_code,pu_vendname,pr_code"
        placeholder="输入变更单号、供应商、物料编号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/purchase/order_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pu_vendname}}</p>
            <p class="list-item-muted">{{item.pc_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'yyyy-MM-dd'">{{item.pu_date}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.pc_status!='已审核'}"
            >{{item.pc_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}笔</label>
        <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pu_total')}}</em> -->
      </div>
      <add-button to="/purchase/order_edit" />
    </div>

    <div class="page page__list" v-if="filters[0].name == 'pi_date'">
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.pi_id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.ve_name}}</p>
            <p class="list-item-muted">{{item.pi_inoutno}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
            <p class="list-item-muted" v-if="item.expressInfo">{{item.expressInfo.expressInc}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="filters[0].name == 'purcrebate.createTime'">
      <search-bar
        @search="onSearch"
        name="pur_code,pur_vendname,pr_detail"
        placeholder="输入单据编号、供应商、物料进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/purchase/rebate/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pur_vendname}}</p>
            <p class="list-item-muted">{{item.pur_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pr_detail}}</p>
            <p class="list-item-muted" v-format="'¥#,##0.00'">{{item.pur_amount}}</p>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import listCustomization from "@/mixins/listCustomization.js";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list,listCustomization],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      params: {
        caller: 'Purchase',
        name: 'purchase-purchase-querypanel-MAIN', 
      },
      listUrl: "/api/purchase/purchase/list",
      filters: [
        {
          type: "date",
          name: "pu_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待收货",
              condition: ""
            },
            {
              value: 2,
              label: "待入库",
              condition:
                "pu_status='已审核' and ifnull(pd_bussStatuscode,' ')<>'CLOSE' and pd_qty>ifnull(pd_yqty,0)",
              mode: "DETAIL"
            },
            {
              value: 3,
              label: "待对账",
              condition:
                "pu_status='已审核' and ifnull(pd_acceptqty,0)*ifnull(pd_price,0)>ifnull(pd_checkamount,0)  and  ifnull(pd_acceptqty,0)*ifnull(pd_price,0)>ifnull(pd_payamount,0)",
              mode: "DETAIL"
            },
            {
              value: 4,
              label: "待付款",
              condition:
                "pu_status='已审核' and exists(select 1 from purchasedetail b where ifnull(b.pd_acceptqty,0)*ifnull(b.pd_price,0)>ifnull(b.pd_payamount,0) and b.pd_puid=pu_id)"
            },
            {
              value: 5,
              label: "已入库",
              condition: "pu_status='已审核' and ifnull(pd_acceptqty,0)>0",
              mode: "DETAIL"
            },
            {
              value: 6,
              label: "已取消",
              condition: "IFNULL(pd_bussStatuscode,' ')='CLOSE'",
              mode: "DETAIL"
            },
            {
              value: 7,
              label: "待变更",
              condition: "pc_statuscode='SUBMITTED'"
            },
            {
              value: 8,
              label: "已变更",
              condition: "pc_statuscode='AUDITED'"
            },
            {
              value: 9,
              label: "返利明细",
              condition: ""
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      if(filter.value == 9) {
        this.listUrl = '/api/purchase/rebate/list'
        this.filters[0].name = 'purcrebate.createTime'
      } else if(filter.value >= 7 && filter.value <= 8) {
        this.listUrl = '/api/purchase/change/list'
        this.filters[0].name = 'PurchaseChange.createTime'
      } else if(filter.value == 1) {
        this.listUrl = '/api/purchase/purchase/S2STurnPurcIn/list'
        this.filters[0].name = 'pi_date'
      } else {
        this.listUrl = '/api/purchase/purchase/list'
        this.filters[0].name = 'pu_date'
      }
      filterBar.initConfig()
      next()
    },
    gotoView(item) {
      this.$router.push({
        name: "PurchaseS2STurnPurcIn",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  }
};
</script>